import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IThirdPartyReportState } from './third-party-report';

const exampleStateSelector = createFeatureSelector<IThirdPartyReportState>('thirdPartyReport');

export const selectReteterzaReport = createSelector(
  exampleStateSelector,
  (state: IThirdPartyReportState) => state.reteterzaReport
);

export const selectResponseReteterzaReport = createSelector(
  exampleStateSelector,
  (state: IThirdPartyReportState) => state.selectResponseReteterzaReport
);

export const selectRetiLockerReport = createSelector(
  exampleStateSelector,
  (state: IThirdPartyReportState) => state.retiLockerReport
);

export const selectRetrievePuntoPosteLocker = createSelector(
  exampleStateSelector,
  (state: IThirdPartyReportState) => state.reponsePuntoPosteLocker
);

export const selectDettaglioPuntoPoste = createSelector(
  exampleStateSelector,
  (state: IThirdPartyReportState) => state.dettaglioPuntoPoste
);

export const selectDettaglioPuntoPosteLocker = createSelector(
  exampleStateSelector,
  (state: IThirdPartyReportState) => state.dettaglioPuntoPosteLocker
);
